import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowForward as ArrowIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import HomeSection from "./HomeSection";
import { useGetCommunityFeedQuery } from "../../store/api/communityApi";
import { brandOutlinedButtonSx } from "../../utils/brandAssets";
import { communityAppPath, isOfficialDailyDebate } from "../../utils/community";
import DebateCard from "../community/DebateCard";
import FeaturedChallengeCard from "../community/FeaturedChallengeCard";
import MatchupCard from "../community/MatchupCard";
import RosterCard from "../community/RosterCard";

const CommunityModule = ({ sport = "mlb" }) => {
  const { data } = useGetCommunityFeedQuery(sport);
  if (!data) return null;

  const matchups = data.trending?.matchups || [];
  const rosters = data.trending?.rosters || [];
  const debates = (data.trending?.debates || []).filter(
    (debate) => !isOfficialDailyDebate(debate)
  );
  if (
    !data.featuredChallenge &&
    matchups.length === 0 &&
    rosters.length === 0 &&
    debates.length === 0
  ) {
    return null;
  }

  return (
    <HomeSection
      title="Community"
      subtitle="Featured challenges, roster battles, and published lineups."
      action={
        <Button
          component={RouterLink}
          to={communityAppPath(sport)}
          endIcon={<ArrowIcon />}
          sx={brandOutlinedButtonSx}
        >
          Open Community
        </Button>
      }
    >
      <Box sx={{ display: "grid", gap: 2 }}>
        {data.featuredChallenge && (
          <FeaturedChallengeCard challenge={data.featuredChallenge} sport={sport} />
        )}
        {debates.map((debate) => (
          <DebateCard key={debate.id} debate={debate} sport={sport} />
        ))}
        {matchups.map((matchup) => (
          <MatchupCard key={matchup.id} matchup={matchup} sport={sport} />
        ))}
        {rosters.length > 0 && (
          <Box>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
              Popular rosters
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 1.5,
              }}
            >
              {rosters.slice(0, 2).map((roster) => (
                <RosterCard key={roster.id} roster={roster} sport={sport} />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </HomeSection>
  );
};

export default CommunityModule;
